module.exports = __webpack_public_path__ + "img/sogal.0b405022.jpg";